import React, { useEffect } from "react";
import "./App.css";
import "./Dashboardcontent.css";
import "./components/Home.css";
import "./Admin/OrderDetails.css";
import "./components/Sidebar.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { lazy, Suspense } from "react";
import Spinners from "./components/Spinners";
import Spark from "./components/Spark";
import ReactGA from "react-ga4";

const Plan = lazy(() => import("./Admin/Plan"));
const Dashboard = lazy(() => import("./Admin/Dashboard"));
const Login = lazy(() => import("./components/Login"));

function App() {
  useEffect(() => {
    ReactGA.initialize("G-PCJGCXSTKS");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <>
      <Suspense fallback={<Spinners />}>
        <Router basename="/fyvaseller_frontend/app">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Dashboard/*" element={<Dashboard />} />
            <Route path="/plans" element={<Plan />} />
            <Route path="/spark" element={<Spark />} />
          </Routes>
        </Router>
      </Suspense>
      <Toaster position="top-center" />
    </>
  );
}

export default App;
